import type { SensorsQueryVariables, Sensors_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function deleteSensors(arr: Array<string>): Sensors_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function restoreSensors(arr: Array<string>): Sensors_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultSensorVars: SensorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { model: Order_By.Asc }
  ]
};

export const adminSensorVars: SensorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { model: Order_By.Asc }
  ]
};

export const kocSensorVars: SensorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { model: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_koc_timestamp: { _is_null: false } },
      { only_koc_timestamp: { _is_null: false } }
    ]
  }
};
export const ecopetrolSensorVars: SensorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { model: Order_By.Asc }
  ],
  where: {
    _or: [
      { include_ecopetrol_timestamp: { _is_null: false } },
      { only_ecopetrol_timestamp: { _is_null: false } }
    ]
  }
};
